var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTimecards = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Timecard",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788",
    transform: "translate(0.58 0.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M17.672,11.455V3.213a1.608,1.608,0,0,0-1.607-1.606H14.057a.4.4,0,0,0-.4.4V4.016a.8.8,0,1,1-1.07-.752.4.4,0,0,0,.267-.378V.4a.4.4,0,1,0-.8,0v1.2H6.025a.4.4,0,0,0-.4.4V4.016a.8.8,0,1,1-1.07-.752.4.4,0,0,0,.267-.378V.4a.4.4,0,0,0-.8,0v1.2H1.607A1.608,1.608,0,0,0,0,3.213V16.065a1.608,1.608,0,0,0,1.607,1.606h9.849a4.416,4.416,0,1,0,6.217-6.216ZM10.443,14.86a4.4,4.4,0,0,0,.171,1.2H1.607V6.426H16.065v4.187a4.406,4.406,0,0,0-5.623,4.247Zm5.907,1.489a.4.4,0,0,1-.568,0l-1.2-1.2a.4.4,0,0,1-.118-.284V12.45a.4.4,0,0,1,.8,0v2.243l1.087,1.087A.4.4,0,0,1,16.349,16.349Z",
    fill: "#09819a"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimecards, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/timecards.a8a78c54.svg";
export { ForwardRef as ReactComponent };